export default function TimeIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
            <path fill="#EE8A22" d="M41.8 80a38.2 38.2 0 1 0 0-76.3 38.2 38.2 0 0 0 0 76.3Z"/>
            <path fill="#53575A" d="M39.4 78.8a39.4 39.4 0 1 1 0-78.9 39.4 39.4 0 0 1 0 78.9Zm0-76.4a37 37 0 1 0 0 74 37 37 0 0 0 0-74Z"/>
            <path fill="#fff" d="M41.8 72.3a30.4 30.4 0 1 0 0-60.9 30.4 30.4 0 0 0 0 60.9Z"/>
            <path fill="#53575A" d="M39.4 71a31.7 31.7 0 1 1 0-63.3 31.7 31.7 0 0 1 0 63.4Zm0-60.8a29.3 29.3 0 1 0 0 58.5 29.3 29.3 0 0 0 0-58.5Z"/>
            <path fill="#53575A" d="M52 53.7 38.4 40.3c-.2-.3-.3-.6-.3-1V14.7h2.4V39l13 13-1.6 1.8Z"/>
        </svg>
    )
}